var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"append-to-body":"","close-on-click-modal":false,"title":"视频预览","visible":_vm.dialogVisible,"width":"60%"},on:{"close":_vm.handleClose}},[_c('div',{staticClass:"videoBox"},[_c('video',{staticClass:"video",attrs:{"autoplay":"","controls":"","src":_vm.videoUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }